import React from 'react';
import { 
  LayoutGrid, 
  Shield, 
  Car, 
  Smartphone, 
  Layers, 
  TestTube, 
  Brain, 
  FileText,
  Users
} from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  'program-management': LayoutGrid,
  'process-compliance': Shield,
  'automotive-software': Car,
  'mobile-engineering': Smartphone,
  'architecture-design': Layers,
  'testing-quality': TestTube,
  'ai-services': Brain,
  'rfq-support': FileText,
  'staffing': Users
};

const Services = () => {
  return (
    <section className="section-padding" id="services" style={{ background: 'var(--bg-secondary)' }}>
      <div className="container">
        <div className="section-header">
          <p className="section-label">Our Services</p>
          <h2 className="section-title">Comprehensive Consulting Solutions</h2>
          <p className="section-description">
            End-to-end consulting and staffing services across software engineering, program management, 
            and quality assurance—with deep expertise in <span style={{ color: 'var(--accent-primary)', fontWeight: '600' }}>Automotive</span> and <span style={{ color: 'var(--accent-primary)', fontWeight: '600' }}>Mobile</span> domains.
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service) => {
            const IconComponent = iconMap[service.id] || LayoutGrid;
            return (
              <div key={service.id} className="service-card">
                <div className="service-icon">
                  <IconComponent size={24} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
